import { RouteObject } from 'react-router-dom';

const route: RouteObject = {
  index: true,
  lazy: async () => ({ Component: (await import('./scene')).default }),
};
export default route;
